import styled from 'styled-components';

export const RatingWrapper = styled.div`
  display: inline-block;

  & > svg {
    margin: -5px -5px;
  }
`;
